module.exports = __webpack_public_path__ + "static/media/Tiger_Main.95385dc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Tiger_Main.jpg
// module id = 354
// module chunks = 0